export const baseImageGraphqlFields = `
  publicId
  uuid
`;
